import {
  config,
  createRequestIdToInstrumentMap,
  NetDania,
} from './create-request-id-to-instrument-map'
import anime from 'animejs/lib/anime.es'
import { differenceInSeconds } from 'date-fns'
import 'requestidlecallback-polyfill'

export function initGraph($) {
  function initGraphInner() {
    let myLine1
    const themeIntrMap = {}
    let i = 0
    // region Render Chart
    document
      .querySelectorAll('[data-instrument-symbol][data-instrument-provider]')
      .forEach((e: HTMLElement) => {
        const config1 = JSON.parse(JSON.stringify(config))
        config1.id = e.id
        config1.containerId = e.id
        config1.defaultInstrument.symbol = e.dataset.instrumentSymbol
        config1.defaultInstrument.provider = e.dataset.instrumentProvider
        if (themeIntrMap[e.dataset.instrumentSymbol] !== undefined) {
          i = themeIntrMap[e.dataset.instrumentSymbol]
        } else {
          themeIntrMap[e.dataset.instrumentSymbol] = i
        }
        myLine1 = new NetDania.Controls.FSC(config1)
        myLine1.setTheme(
          i % 3 === 0 ? 'uf1' : i % 3 === 1 ? 'uf2' : i % 3 === 2 ? 'uf3' : ''
        )
        i++
      })
    // endregion
    const instrumentMap = createRequestIdToInstrumentMap(myLine1)
    // region Render Text
    const renderForInstrument = (
      instr,
      props: { stored: any },
      timedRender = false
    ) => {
      Array.from(
        document.querySelectorAll(`[data-instrument-symbol="${instr}"]`)
      ).forEach(e => {
        const container = $(e)
          .closest('.graph-slide')
          .find('div.graph-slide__text-container')[0]
        const diff =
          Number(props.stored.latest) - Number(props.stored.QUOTE_CLOSE)
        const price = Number(props.stored.latest)

        if (instr === '' || typeof instr !== 'string') {
          return
        }
        let [symbol, currency] = instr.split('.')
        if (currency === undefined) {
          currency = symbol.slice(-3)
        }

        const cls =
          Number(props.stored.latest) < Number(props.stored.QUOTE_CLOSE)
            ? 'graph-slide__text-line--arrow-down'
            : 'graph-slide__text-line--arrowdefault'
        container.innerHTML = `
                <p class='graph-slide__text-line ${cls}'>${price.toLocaleString(
          'en-US',
          { minimumFractionDigits: 2, currency: currency, style: 'currency' }
        )}</p>
                <p class='graph-slide__text-line-small'>${diff.toLocaleString(
                  'en-US',
                  { minimumFractionDigits: 2 }
                )} ${(diff / price).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          style: 'percent',
        })}</p>
`
        const hasDiff = Math.abs(props.stored.diff) > 0.01
        if (timedRender) {
          anime.remove(container)
          anime({
            targets: container,
            color: [
              { value: 'rgba(255,255,255,1)', duration: 0 },
              {
                value: diff > 0 ? 'rgba(49,205,148,1)' : 'rgba(255,51,61,1)',
                duration: 500,
              },
              { value: 'rgba(255,255,255,1)', delay: 1000 },
            ],
            duration: 3000,
            easing: 'linear',
          })
        } else if (hasDiff) {
          anime.remove(container)
          anime({
            targets: container,
            color: [
              { value: 'rgba(255,255,255,1)', duration: 0 },
              {
                value:
                  props.stored.diff > 0
                    ? 'rgba(49,205,148,1)'
                    : 'rgba(255,51,61,1)',
                duration: 500,
              },
              { value: 'rgba(255,255,255,1)', delay: 1000 },
            ],
            duration: 3000,
            easing: 'linear',
          })
        }
      })
    }
    // endregion
    // region Update Data
    let store = {}
    const reducer = (s, a) => {
      switch (a.type) {
        case 'ONPRICEUPDATE':
          if (a.payload.latest === 'N/A') {
            a.payload.latest = null
          }
          if (isNaN(a.payload.latest - (s[a.payload.id]?.latest ?? 0))) {
            console.log(a.payload.latest, s[a.payload.id]?.latest ?? 0)
          }
          return {
            ...s,
            [a.payload.id]: {
              ...a.payload,
              lastRendered: new Date(),
              latest:
                a.payload.latest !== 'N/A' && a.payload.latest != null
                  ? a.payload.latest
                  : s[a.payload.id]?.latest,
              diff:
                a.payload.latest -
                (s[a.payload.id]?.latest ?? a.payload.latest),
              name:
                a.payload.name !== 'N/A'
                  ? a.payload.name
                  : s[a.payload.id].name,
              QUOTE_CLOSE:
                a.payload.QUOTE_CLOSE !== 'N/A' && a.payload.QUOTE_CLOSE != null
                  ? a.payload.QUOTE_CLOSE
                  : s[a.payload.id]?.QUOTE_CLOSE,
            },
          }
        case 'ONERROR':
          return s
        case 'timedRender':
          return {
            ...s,
            [a.payload.id]: {
              ...s[a.payload.id],
              lastRendered: new Date(),
            },
          }
        default:
          return s
      }
    }
    const dispatch = action => {
      store = reducer(store, action)
    }
    myLine1.chartApi.connection.addListener(
      NetDania.JsApi.Events.ONCHARTUPDATE,
      f => {
        try {
          const ts = f.ts
          const timestamp = ts === 'N/A' ? ts : new Date(ts * 1000)
          const payload = {
            timestamp,
            latest: f.data.find(
              fv => fv.f === NetDania.JsApi.Fields.CHART_CLOSE
            ).v,
            id: instrumentMap[f.id]?.instr,
          }
          dispatch({ type: 'ONPRICEUPDATE', payload: payload })
        } catch (ex) {
          console.log(ex)
        }
        const instr = instrumentMap[f.id].instr
        renderForInstrument(instr, { stored: store[instr] })
      }
    )
    myLine1.chartApi.connection.addListener(
      NetDania.JsApi.Events.ONPRICEUPDATE,
      f => {
        const monitorPriceResponse = f
        try {
          const ts = monitorPriceResponse.get(
            NetDania.JsApi.Fields.QUOTE_TIME_STAMP
          )
          const timestamp = ts === 'N/A' ? ts : new Date(ts * 1000)
          const payload = {
            timestamp,
            name: monitorPriceResponse.get(NetDania.JsApi.Fields.QUOTE_NAME),
            fullName: monitorPriceResponse.get(
              NetDania.JsApi.Fields.QUOTE_FULL_NAME
            ),
            latest: monitorPriceResponse.get(NetDania.JsApi.Fields.QUOTE_LAST),
            QUOTE_CLOSE: monitorPriceResponse.get(
              NetDania.JsApi.Fields.QUOTE_CLOSE
            ),
            id: instrumentMap[f.id]?.instr,
          }
          dispatch({ type: 'ONPRICEUPDATE', payload: payload })
          // console.log(store);
        } catch (ex) {
          console.log(ex)
        }
        const instr = instrumentMap[f.id].instr
        renderForInstrument(instr, { stored: store[instr] })
      }
    )
    // endregion

    // region Call renderForInstrument on an interval
    const instruments = Object.values(instrumentMap).map(v => v.instr)
    setInterval(() => {
      for (let i = 0; i < instruments.length; i++) {
        const number = store[instruments[i]]?.lastRendered
          ? differenceInSeconds(
              new Date(),
              new Date(store[instruments[i]].lastRendered)
            )
          : 0
        if (number > 5) {
          dispatch({ type: 'timedRender', payload: { id: instruments[i] } })
          renderForInstrument(
            instruments[i],
            { stored: store[instruments[i]] },
            true
          )
        }
      }
    }, 1000)
    // endregion
  }

  window.requestIdleCallback(initGraphInner)
}
